export default {
  ability: 'Habilidad',
  resourceType: 'Tipo de recurso',
  reviews: 'Sin valoraciones | {n} valoración | {n} valoraciones',
  agesTag: '{min} a {max} años',
  agesTagNone: 'Ninguno',
  citizenship: 'Ciudadanía Global',
  by: 'por {n}',
  category: {
    computationalThinking: 'Pensamiento computacional',
    globalCitizenship: 'Ciudadanía global',
    entrepreneurialSpirit: 'Espíritu emprendedor',
    teachersTraining: 'Acompañamiento docente'
  },
  untitled: 'Sin título',
  saveResourceInFolder: 'Guardar en Carpeta',
  removeResourceFromFolder: 'Eliminar recurso de la carpeta',
  noLanguage: 'Sin idioma',
  addLanguage: 'Agregar en {locale}'
}

export const en = {
  ability: 'Skill',
  resourceType: 'Type of resource',
  reviews: 'No reviews | {n} review | {n} reviews',
  agesTag: '{min} to {max} y/o',
  agesTagNone: 'None',
  citizenship: 'Global Citizenship',
  by: 'by {n}',
  category: {
    computationalThinking: 'Computational thinking',
    globalCitizenship: 'Global citizenship',
    entrepreneurialSpirit: 'Entrepreneurial spirit',
    teachersTraining: 'Teacher guidance'
  },
  untitled: 'Untitled',
  saveResourceInFolder: 'Save to Folder',
  removeResourceFromFolder: 'Remove resource from folder',
  noLanguage: 'No language',
  addLanguage: 'Add to {locale}'
}

export const ca = {
  ability: 'Habilitat',
  resourceType: 'Tipus de recurs',
  reviews: 'Sense valoracions | {n} valoració | {n} valoracions',
  agesTag: 'De {min} a {max} anys',
  agesTagNone: 'Cap',
  citizenship: 'Ciutadania Global',
  by: 'per {n}',
  category: {
    computationalThinking: 'Pensament computacional',
    globalCitizenship: 'Ciutadania global',
    entrepreneurialSpirit: 'Esperit emprenedor',
    teachersTraining: 'Acompanyament docent'
  },
  untitled: 'Sense títol',
  saveResourceInFolder: 'Afegeix a la Carpeta',
  removeResourceFromFolder: 'Eliminar recurs de la carpeta',
  noLanguage: 'Sense idioma',
  addLanguage: 'Afegir a {locale}'
}
